import { createFileRoute } from '@tanstack/react-router';
import { AdminSubjectDraftProvider } from '@/contexts';
import { AddSubjectWizard } from '@/components';

const SubjectsNewPage = () => {
  const { areaSlug } = Route.useParams();
  return (
    <AdminSubjectDraftProvider areaSlug={areaSlug} draftKey={`${areaSlug}-new`} isNew>
      <AddSubjectWizard />
    </AdminSubjectDraftProvider>
  );
};

export const Route = createFileRoute('/_adminLayout/admin/areas/$areaSlug/subjects/new')({
  component: SubjectsNewPage
});
